let config = {
    title: 'Jujutsu Masters: Cursed Rivals',
    email: 'support@jujutsumasterscursedrivals.com ',
    policy: 'https://jujutsumasterscursedrivals.com/privacy_policy.html',
    term: 'https://jujutsumasterscursedrivals.com/terms.html', 
    copyright: 'Ronghua Trading Limited',
    introduceTitle: [
        'Immerse yourself in the world of Jujutsu Masters: Cursed Rivals, where ancient powers clash in a battle for supremacy. As a jujutsu sorcerer, you must harness your abilities to overcome formidable adversaries and save the world from impending doom. ',
        // 'With stunning graphics, intense gameplay, and a captivating storyline, this game will keep you on the edge of your seat until the very end.'
    ],
    introduceText: [
        {
            title: 'With stunning graphics, intense gameplay, and a captivating storyline, this game will keep you on the edge of your seat until the very end.',
            text: [
                // 'The international phenomenon Tower of God, reimagined by Netmarble.'
            ]
        },
        {
            title: 'Master the art of Jujutsu: Learn powerful techniques and unleash devastating combos to defeat your enemies.',
            text: [
                // 'Meet Bam, Khun, and Rak as well as the entire supporting cast from the webtoon!',
                // 'Become part of their adventure and experience exclusive original stories as you forge your path forward on your climb up the Tower of God!'
            ]
        },
        {
            title: 'Explore diverse environments: Traverse mystical realms and uncover hidden secrets as you journey through the game.',
            text: [
                // 'The international phenomenon Tower of God, reimagined by Netmarble.'
            ]
        },
        {
            title: 'Build your team: Recruit allies and assemble a formidable squad to take on the forces of darkness.',
            text: [
                // 'Meet Bam, Khun, and Rak as well as the entire supporting cast from the webtoon!',
                // 'Become part of their adventure and experience exclusive original stories as you forge your path forward on your climb up the Tower of God!'
            ]
        },
        {
            title: 'Engage in epic battles: Challenge powerful bosses and test your skills in thrilling combat encounters.',
            text: [
                // 'The international phenomenon Tower of God, reimagined by Netmarble.'
            ]
        },
        {
            title: 'Customize your character: Choose from a variety of weapons, armor, and abilities to create your ultimate warrior.',
            text: [
                // 'Meet Bam, Khun, and Rak as well as the entire supporting cast from the webtoon!',
                // 'Become part of their adventure and experience exclusive original stories as you forge your path forward on your climb up the Tower of God!'
            ]
        },
        {
            title: 'Compete in multiplayer modes: Test your skills against players from around the world and rise to the top of the leaderboards.',
            text: []
        },
        {
            title: 'Are you ready to embrace your destiny and become a legendary Jujutsu Master? Join the fight now and unleash the power within!',
            text: []
        }
    ]
}
export default config;